import { trackSegmentAndGAEvent } from '@zoopla/tracking';

export const trackMenuItem = (label: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'account_navigation',
            eventLabel: label,
            eventAction: 'click'
        },
        page
    );
};

export const trackMenuShown = (page: string) => {
    trackSegmentAndGAEvent(
        'Module Shown',
        {
            eventCategory: 'account_navigation',
            eventLabel: 'open_nav',
            eventAction: 'click'
        },
        page
    );
};

export const trackMenuClose = (page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'account_navigation',
            eventLabel: 'close_nav',
            eventAction: 'click'
        },
        page
    );
};
